/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { UserService } from 'app/core/services/user-service';
import { guid } from 'app/shared/lib/guid';
import { apiCall } from 'app/shared/lib/essette-api';
import * as Core from 'app/core/models/essette-api';

@autoinject()
export class SaveUser extends ComponentBase {
    ////****************** Fields and Properties ************************************////
    protected id: guid = guid();
    protected createOption: string = 'localUser';
    protected signOnProviders: Core.SignOnProvider[] = [];

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        protected readonly userService: UserService,
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** Events ***************************************************////
    protected bind(): void {
        this.loadSignOnProviders();
    }


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadSignOnProviders(): Promise<boolean> {
        const includes: string[] = [];
        const fields: string[] = ['description'];

        let isSuccessful = false;
        try {
            this.state.beginSave();
            //OIDC-MSAL is the only signon provider code we support. If this changes in the future, larger redesign may be in order.
            const response = await this.userService.loadSignOnProvidersByCode(includes, fields, 'OIDC-MSAL');
            this.signOnProviders = response.results;
            isSuccessful = response.isSuccessful;
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endSave();
            return isSuccessful;
        }
    }
}
